<template>
  <div class="start">
    <div class="start__text">
      <Container>
        <Margins>
          <h2>
            {{ $t('START_QUESTION') }}
          </h2>

          <p class="start__description margins__triple">
            {{ $t('START_DESCRIPTION_1') }}
            <br />
            {{ $t('START_DESCRIPTION_2') }}
          </p>
        </Margins>
      </Container>
    </div>
    <div class="start__question">
      <Container>
        <Margins>
          <h3 class="h5">{{ $t('FIRST_QUESTION') }}</h3>

          <Options
            :decision="decision"
            class="margins__triple"
            @change="assignVariable"
          />

          <Info
            v-if="$mt(question.description) || $mt(question.help)"
            :title="$mt(question.description)"
            :text="$mt(question.help)"
            :open="$t('OPEN')"
            :close="$t('CLOSE')"
          />
        </Margins>
      </Container>
    </div>

    <b-modal
      v-if="$i18n.locale === 'sv'"
      :visible="!customerType"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      centered
      modal-class="customer-type-modal"
    >
      <div class="customer-type-modal__content">
        <h3 class="customer-type-modal__title">
          {{ $t('CUSTOMER_TYPE.MODAL_TITLE') }}
        </h3>
        <div class="customer-type-modal__buttons">
          <Button variant="inverse" @click="selectCustomerType('legal')">
            {{ $t('CUSTOMER_TYPE.LEGAL') }}
          </Button>
          <Button variant="inverse" @click="selectCustomerType('private')">
            {{ $t('CUSTOMER_TYPE.PRIVATE') }}
          </Button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import Margins from '@/components/Margins';
import Options from '@/components/Options';
import Container from '@/components/Container';
import Info from '@/components/Info';
import Button from '@/components/Button';

export default {
  name: 'Start',
  components: {
    Margins,
    Options,
    Container,
    Info,
    Button,
  },
  data() {
    return {
      questionVariables: {},
      error: false,
    };
  },
  methods: {
    ...mapActions(['evaluateAnswer']),
    ...mapMutations(['setCustomerType']),
    assignVariable(key, value) {
      this.questionVariables[key] = value;
      this.error = false;
      this.handleNext();
    },
    handleNext() {
      if (Object.keys(this.questionVariables).length === 0) {
        this.error = true;
        return false;
      }

      return this.evaluateAnswer({
        answerVariables: this.questionVariables,
        question: this.question,
      });
    },
    selectCustomerType(type) {
      this.setCustomerType(type);
    },
  },
  computed: {
    ...mapGetters(['questions']),
    ...mapState(['customerType']),
    question() {
      return this.questions?.[0] || {};
    },
    decision() {
      return this.question.decisions?.[0] || {};
    },
  },
};
</script>

<style lang="scss">
.start__text {
  position: relative;
  background: $color-secondary;
  padding-top: 7vh;
  padding-bottom: 7vh;
}

.start__description {
  font-size: $h5-size;
}

.start__question {
  padding-top: 7vh;
}

.customer-type-modal {
  .modal-content {
    border: 2px solid $color-primary;
    background-color: $color-secondary;
  }
}

.customer-type-modal__content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 0.5rem;

  @include min-width(md) {
    flex-direction: row;
    align-items: center;
  }
}

.customer-type-modal__title {
  flex: 1;
  margin-bottom: 0;
}

.customer-type-modal__buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  flex: 2;
}
</style>
